import type { Disposition, MatchResult } from './types';

// Shaped to satisfy StyledDataSheet's injected TagColorData (which requires `origin`);
// only `carryState` drives the colours the review stage needs.
export type TagMarkerData = Record<string, { origin: 'human'; carryState?: string }>;

const CARRIED = { origin: 'human' as const, carryState: 'carried' };
const FLAGGED = { origin: 'human' as const, carryState: 'flagged' };
const UNMATCHED = { origin: 'human' as const, carryState: 'unmatched' };
const DROPPED = { origin: 'human' as const, carryState: 'dropped' };

const stateOf = (disposition: Disposition) => {
  if (disposition === 'unmatched') return UNMATCHED;
  if (disposition === 'flag') return FLAGGED;
  return CARRIED;
};

export function carryTagData(results: MatchResult[] = [], reattached: Map<string, unknown> = new Map(), dropped: Set<string> = new Set()): TagMarkerData {
  const map: TagMarkerData = {};
  results.forEach((r) => {
    if (reattached.has(r.tagId)) map[r.tagId] = FLAGGED;
    else if (dropped.has(r.tagId)) map[r.tagId] = DROPPED;
    else map[r.tagId] = stateOf(r.disposition);
  });
  reattached.forEach((_, tagId) => {
    map[tagId] = FLAGGED;
  });
  return map;
}
